<template>
  <div>


    <b-container class="float-left">

      <b-row class="mb-2">
        <b-col md="4">
          <div class="text-left mt-2 mb-1">
            <h4 class="font-weight-bold">Innstillinger</h4>
          </div>
        </b-col>

        <b-col md="8">
          <div class="text-right mt-1 mb-3">
            <b-btn
              class="mr-2"
              variant="default"
              @click="goDashboard()"
            >Avbryt</b-btn>
            <b-btn
              variant="primary"
              @click="saveSettings()"
            >Lagre endringer</b-btn>
          </div>
        </b-col>
      </b-row>

      <!-- Settings -->
      <b-row>
        <b-col md="4">
          <h5>Selskap</h5>
          <p></p>

        </b-col>

        <b-col md="8">

          <b-card>

            <h6>Selskap</h6>
            <hr />

            <b-form-group label="Navn">
              <b-input v-model="company.name" />
            </b-form-group>

            <b-form-group label="Org. nummer">
              <b-input
                disabled
                v-model="company.orgnumber"
              />
            </b-form-group>

            <b-form-group label="Beskrivelse">
              <b-input v-model="company.description" />
            </b-form-group>

            <b-form-group label="Webside">
              <b-input v-model="company.website" />
            </b-form-group>

            <b-form-group label="Telefon">
              <b-input v-model="company.phone" />
            </b-form-group>

            <b-form-group label="E-post">
              <b-input v-model="company.email" />
            </b-form-group>

          </b-card>

        </b-col>
      </b-row>

      <hr>

      <!-- Logo -->

      <b-row>
        <b-col md="4">
          <h5>Logo</h5>
          <p></p>

        </b-col>

        <b-col md="8">

          <b-card>

            <div class="mb-3" v-if="company.logo != null">
                    <b-img thumbnail fluid :src="company.logo.url" ></b-img>


            </div>

            <b-form-file v-model="selectedFile" accept="image/*" browse-text="Velg" placeholder="Ingen fil valgt"
              drop-placeholder="Dra og slipp fil her"></b-form-file>

            <br>
            <b-button v-if="selectedFile == null" variant="outline-primary" disabled>Last
              opp</b-button>
            <b-button v-if="selectedFile != null" variant="primary" @click="uploadLogo()">Last opp</b-button>


          </b-card>

        </b-col>
      </b-row>

      <hr>

      <!-- Contact information -->

      <b-row>
        <b-col md="4">
          <h5>Kontaktopplysninger</h5>
          <p></p>

        </b-col>

        <b-col md="8">

          <b-card>

            <h6>Adresse</h6>
            <hr>

            <b-form-group label="Adresse">
              <b-input v-model="company.address" />
            </b-form-group>

            <b-form-group label="Postkode">
              <b-input v-model="company.postcode" />
            </b-form-group>

            <b-form-group label="Poststed">
              <b-input v-model="company.city" />
            </b-form-group>

            <b-form-group label="Land">
              <b-input v-model="company.country" />
            </b-form-group>

            <br>

            <h6>Kontaktperson</h6>
            <hr>

            <b-form-group label="Navn">
              <b-input v-model="company.contact_name" />
            </b-form-group>

            <b-form-group label="E-post">
              <b-input v-model="company.contact_email" />
            </b-form-group>

            <b-form-group label="Telefon">
              <b-input v-model="company.contact_phone" />
            </b-form-group>

          </b-card>

        </b-col>
      </b-row>

      <hr>

      <!-- Company Users -->

      <b-row>
        <b-col md="4">
          <h5>Brukere</h5>
          <p></p>

        </b-col>

        <b-col md="8">

          <b-card>

            <b-table
              striped
              hover
              :fields="fields"
              :items="users"
            ></b-table>

            <b-button
              class="mt-1 mb-3 float-left"
              variant="primary"
              v-b-modal.newUser
            >Opprett bruker</b-button>

            <b-modal
              id="newUser"
              title="Ny bruker"
            >
              <b-form-group
                label="Navn"
                label-for="name-input"
              >
                <b-form-input v-model="newuser.username"></b-form-input>
              </b-form-group>

              <b-form-group
                label="E-post"
                label-for="name-input"
              >
                <b-form-input
                  v-model="newuser.email"
                  type="email"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Passord">
                <b-form-input
                  v-model="newuser.password"
                  type="password"
                ></b-form-input>
              </b-form-group>

              <!-- <b-form-group label="Type">
                <b-form-select
                  class="mr-3 mb-3"
                  v-model="order.type"
                  :options="orderType"
                  placeholder="Type"
                ></b-form-select>
              </b-form-group> -->

              <b-form-group label="Rolle">
                <b-form-select
                  class="mr-3 mb-3"
                  v-model="role"
                  :options="roleOptions"
                ></b-form-select>
              </b-form-group>

              <template #modal-footer>
                <div class="w-100">
                  <b-button
                    variant="primary"
                    class="float-right"
                    @click="createUser()"
                  >
                    Opprett ny bruker
                  </b-button>

                  <b-button
                    variant="default"
                    class="float-right mr-2"
                    @click="closeModal()"
                  >
                    Avbryt
                  </b-button>
                </div>
              </template>
            </b-modal>

          </b-card>

        </b-col>
      </b-row>

      <hr>

      <!-- Invoice -->

      <b-row>
        <b-col md="4">
          <h5>Fakturaopplysninger</h5>
          <p></p>

        </b-col>

        <b-col md="8">

          <b-card>

            <b-form-group
              label="Fakturametode for leverandører"
              v-slot="{ ariaDescribedby }"
            >

              <b-form-radio
                v-model="company.invoice_method"
                :aria-describedby="ariaDescribedby"
                name="email"
                value="email"
              >E-post</b-form-radio>
              <b-form-radio
                v-model="company.invoice_method"
                :aria-describedby="ariaDescribedby"
                name="ehf"
                value="ehf"
              >EHF</b-form-radio>
              <b-form-radio
                v-model="company.invoice_method"
                :aria-describedby="ariaDescribedby"
                name="invoice"
                value="invoice"
              >Faktura</b-form-radio>
            </b-form-group>

            <b-form-group
              v-if="company.invoice_method == 'email'"
              label="Faktura e-post"
            >
              <b-input
                v-model="company.invoice_email"
                placeholder="E-postadresse"
              />
            </b-form-group>

            <b-form-group
              v-if="company.invoice_method == 'ehf'"
              label="Faktura EHF "
            >
              <b-input
                v-model="company.invoice_ehf"
                placeholder="Organisasjonsnummer"
              />
            </b-form-group>

            <b-form-checkbox
              class="mt-3 mb-3"
              v-if="company.invoice_method == 'invoice'"
              v-model="company.invoice_asaddress"
            >Bruk samme som adresse</b-form-checkbox>

            <b-form-group
              v-if="company.invoice_method == 'invoice'"
              label="Faktura adresse"
            >
              <b-input v-model="company.invoice_address" />
            </b-form-group>

            <b-form-group
              v-if="company.invoice_method == 'invoice'"
              label="Faktura postnummer"
            >
              <b-input v-model="company.invoice_postcode" />
            </b-form-group>

            <b-form-group
              v-if="company.invoice_method == 'invoice'"
              label="Faktura poststed"
            >
              <b-input v-model="company.invoice_city" />
            </b-form-group>

          </b-card>

        </b-col>
      </b-row>

      <hr>

    </b-container>

  </div>
</template>

<!-- Page -->
<style src="@/vendor/styles/pages/account.scss" lang="scss"></style>

<script>
import axios from "axios";
import { Icon } from "leaflet";

import {
  LMap,
  LTileLayer,
  LMarker,
  LControlLayers,
  LControl,
  LControlZoom,
  LControlAttribution,
  LControlScale,
} from "vue2-leaflet";

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "pages-account-settings",
  metaInfo: {
    title: "Account settings - Pages",
  },
  components: {

    LMap,
    LTileLayer,
    LMarker,
    LControlLayers,
    LControl,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    
  },
  data: () => ({
    user: {},
    newuser: {
      wizard: true,
      language: "no",
    },
    role: "600fe2dc0b7e124b5c5f7f3b",
    users: [],
    company: {},
    sites: [],
    selectedFile: null,
    form: {
      country: {
        label: null,
        data: {},
      },
    },
    fields: [
      { key: "username", label: "Navn", sortable: true },
      { key: "email", label: "E-mail", sortable: true },
      { key: "role.name", label: "Rolle", sortable: true },
    ],
    roleOptions: [
      { value: "600fe2dc0b7e124b5c5f7f3b", text: "Administrator" },
    ],
    optionsInvoice: [
      { text: "E-post", value: "email" },
      { text: "EHF", value: "ehf" },
      { text: "Faktura", value: "invoice" },
    ],
    zoom: 12,
    url:
      "https://api.mapbox.com/styles/v1/packtracker-com/ck8d9hr3y1adz1io2kctelu2y/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
    attribution: '<a href="https://www.packtracker.com">Packtracker</a> ',
    currentZoom: 8,
    marker: {
      position: {
        lat: 62.95645281047797,
        lng: 8.112008459280943,
      },
      draggable: true,
      visible: true,
    },
  }),
  methods: {
    getUser() {
      this.isLoading = true;
      axios.get("https://api.eines-as.no/users/me").then((res) => {
        this.user = res.data;
        this.company = res.data.company;
        this.isLoading = false;
      });
    },
    getUsers() {
      var company = localStorage.getItem("company");

      axios
        .get(
          "https://api.eines-as.no/users?_sort=createdAt:DESC&_where[company]=" +
            company
        )
        .then((res) => {
          this.users = res.data;
        });
    },
    getCompany() {
      axios
        .get(`https://www.aquaservices.no/` + this.company.id)

        .then((res) => {
          this.company = res.data[0];
        });
    },
    createUser() {
      this.isLoading = true;
      this.newuser.company = localStorage.getItem("company");

      axios
        .post("https://api.eines-as.no/auth/local/register", this.newuser)
        .then((response) => {
          this.newuser = response.data.user;
          this.newuser.role = this.role;
          this.$bvModal.hide("newUser");
          axios
            .put(
              "https://api.eines-as.no/users/" + this.newuser.id,
              this.newuser
            )
            .then((response) => {
              this.users.push(response.data);
              this.newuser = {
                wizard: true,
                language: "no",
              };
              this.isLoading = false;
            })
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    saveSettings() {
      this.isLoading = true;
      axios
        .put(
          `https://api.eines-as.no/companies/` + this.company.id,
          this.company
        )
        .then((response) => {
          this.$router.push("/customer/home");
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
      uploadLogo() {
        this.isLoading = true;
        let formData = new FormData()

        formData.append('ref', 'companies');
        formData.append('path', 'companies/' + this.company.id);
        formData.append('refId', this.company.id);
        formData.append('field', 'logo');
        formData.append("files", this.selectedFile, this.selectedFile.name);

        let optionsUpload = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }

        axios.post('https://api.eines-as.no/upload', formData, optionsUpload, )
          .then((response) => {
            this.selectedFile = null
            this.getUser()
            this.isLoading = false;
          })

      },
      onFileChanged(event) {
        this.selectedFile = event.target.files[0]
      },
    centerMap: function () {
      this.center = L.latLng(this.form.country.data.latlng);
      this.zoom = 14;
      (this.marker.visible = true),
        (this.marker.position = this.form.country.data.latlng);
      this.form.country.data = {};
    },
    closeModal() {
      this.$bvModal.hide("newUser");
    },
    goDashboard() {
      this.$router.push("/customer/home");
    },
  },
  created: function () {
    this.getUser();
    this.getUsers();
  },
};
</script>

<style lang="css">
.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  border-color: #e2e2e2;
  background-color: #ffffff;
  color: #801529;
}
</style>
